module.exports = __webpack_public_path__ + "media/src/images/lady-in-cafe-p-800x450-97ba64f60f126932f054573626dbdba7.jpeg";